import React, { useState } from "react";
import MyMap from "../../Maps/MyMap";
import MapIcon from "../../../assets/icons/mapping.svg2";
import Clusters from "../../Maps/Clusters";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";
import HelpButton from "../../HelpContent/HelpButton";
import NewFeature from "../../Builder/Components/NewFeature";

const filters = {
  Contacts: true,
  Assets: true,
  Direct: false,
  Indirect: false,
  ExcludeWithLocation: false,
};

export default function AlertMapWidget() {
  const [loading, setLoading] = useState(false);

  return (
    <div className="h-100 p-3 rounded-3">
      <AbsoluteLoadingIndicator loading={loading} />

      <div className="card-body d-flex flex-column justify-content-between h-100">
        <div className="text-white ">
          <MapIcon width={20} className="me-2 white opacity-50" />
          <span className="small fw-bold widget-header"> ALERT MAP</span>
          <HelpButton helpKey="widget-map" iconClassName="white" />
        </div>
        <hr className="text-white my-2" />
        <NewFeature>
          <MyMap>
            <Clusters filters={filters} setLoading={setLoading} />
          </MyMap>
        </NewFeature>
      </div>
    </div>
  );
}
